import { render, staticRenderFns } from "./TopFirmBadge.vue?vue&type=template&id=26e98cb8&scoped=true"
import script from "./TopFirmBadge.vue?vue&type=script&lang=js"
export * from "./TopFirmBadge.vue?vue&type=script&lang=js"
import style0 from "./TopFirmBadge.vue?vue&type=style&index=0&id=26e98cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e98cb8",
  null
  
)

export default component.exports